import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
    mobileStepperDots: {
        borderRadius: '4px',
        display: 'inline-block',
        marginRight: '12px',
        height: '6px',
        width: '12px',
        backgroundColor: theme.agentTheme.secondary.main,
        transition: 'all 0.5s ease', // smooth transition for width and color
        cursor: 'pointer',
    },
    activeStepperDot: {
        width: '22px',
        backgroundColor: theme.agentTheme.primary.main,
    }
}));

const CarouselStepperDotsFlat = ({ activeStep, handleStepChange, step }) => {
    const classes = useStyles();
    return (
        <span onClick={()=>handleStepChange(step)} className={activeStep ? `${classes.mobileStepperDots} ${classes.activeStepperDot}` : `${classes.mobileStepperDots} ${classes.nonActiveStepperDot}`}></span>
    )
}

export default CarouselStepperDotsFlat;
